import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea3a7786"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "logos" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { onClick: _ctx.closeModal }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ion_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_card_content, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_ion_img, { src: "/assets/thelivery_logo.jpg" }),
                  _hoisted_3,
                  _createVNode(_component_ion_img, {
                    src: _ctx.store.logo
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("h2", null, "Compras na " + _toDisplayString(_ctx.store.name), 1),
                _createElementVNode("p", null, " Para continuar, você será encaminhado para o site das " + _toDisplayString(_ctx.store.name) + ". Boas compras! ", 1),
                _createVNode(_component_ion_button, {
                  shape: "round",
                  expand: "full",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goStore(_ctx.store.id, _ctx.store.link)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ir para a loja")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onClick"]))
}